import { PartnerClientsPageActiveDictionary } from 'types/i18n';
import { sharedDictionaryRu } from './sharedDictionaryRu';

export const partnerDashboardPageActiveDictionaryRu: PartnerClientsPageActiveDictionary = {
  fallbackTitle: 'Нет активных клиентов',
  fallbackDescription: `Привлекайте клиентов, чтобы получать комиссионные.\nПри регистрации клиент должен указать ваш код партнера:`,
  trialClientsStatText(subscriptionsStat, licensesStat) {
    return `Новые клиенты: ${subscriptionsStat} / Лицензий: ${licensesStat}`;
  },
  paidClientTableGroupPrimaryStatText({
    monthDateISO,
    subscriptionsCount,
    licensesCount,
  }) {
    const date = new Date(monthDateISO);

    const monthText = sharedDictionaryRu.dates.monthOfYearDate(date);

    return `${monthText} / Клиенты с подпиской: ${subscriptionsCount} / Лицензий: ${licensesCount}`;
  },
  paidClientTableGroupSecondaryStatText({ totalIncome }) {
    const amountText = sharedDictionaryRu.moneyAmountText(totalIncome, 'USD');

    return `Начислено: ${amountText}`;
  },
};
